var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":""}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":""}},[_c('v-card-text',{staticClass:"py-2 text-center"},[_c('v-divider',{staticClass:"mx-10 ma-2"}),_c('v-img',{attrs:{"src":_vm.logo,"max-height":"40","contain":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }